export type PointerDragCallback = (pageX?: number, pageY?: number) => boolean | void

export type DragManagerUnsubscribe = () => void;

class PointerDragManager {

    dragSubscriptions:PointerDragCallback[] = []
    startSubscriptions:PointerDragCallback[] = []
    stopSubscriptions:PointerDragCallback[] = []
    
    dragging = false;

    handleMouseMove = (e: MouseEvent) => {
        if ((e.buttons & 1) > 0) {
            this.dragging = true;
            if (!this.donotify(this.dragSubscriptions, e.pageX, e.pageY)) 
                e.preventDefault();
        }
    }

    handleMouseStart = (e: MouseEvent) => {
        if ((e.buttons & 1) > 0) {
            this.dragging = true;
            if (!this.donotify(this.startSubscriptions, e.pageX, e.pageY)) 
                e.preventDefault();
        }
    }

    handleMouseEnd = (e: MouseEvent) => {
        if (!this.dragging) return;
        this.dragging = false;
        if (!this.donotify(this.stopSubscriptions, e.pageX, e.pageY)) 
            e.preventDefault();
    }


    handleTouchMove = (e: TouchEvent) => {
        if (!this.donotify(this.dragSubscriptions, e.touches[0].pageX, e.touches[0].pageY)) 
            e.preventDefault();
    }

    handleTouchStart = (e: TouchEvent) => {
        if (!this.donotify(this.startSubscriptions, e.touches[0].pageX, e.touches[0].pageY)) 
            e.preventDefault();
    }

    handleTouchEnd = (e: TouchEvent) => {
        if (!this.donotify(this.stopSubscriptions, 0 , 0)) 
            e.preventDefault();
    }


    initialize(el:HTMLElement) {
        el.addEventListener('touchstart', this.handleTouchStart)
        el.addEventListener('touchmove', this.handleTouchMove)
        el.addEventListener('touchend', this.handleTouchEnd)
        el.addEventListener('touchcancel', this.handleTouchEnd)

        el.addEventListener('mousemove', this.handleMouseMove)
        el.addEventListener('mouseleave', this.handleMouseEnd)
        el.addEventListener('mouseup', this.handleMouseEnd)
        el.addEventListener('mousedown', this.handleMouseStart)
    }


    donotify(notifySet:PointerDragCallback[], pageX: number, pageY:number): boolean {
        var callbackList = notifySet.slice()
        for (var sub of callbackList) {
            if (sub(pageX, pageY) === false) 
                return false;
        }
        return true;
    }

    unsubscriber(collection:PointerDragCallback[], fn: PointerDragCallback): DragManagerUnsubscribe {
        return () => {
            let idx = collection.findIndex(x => x == fn);
            if (idx >= 0) {
                collection.splice(idx,1);
            } else {
                console.log("couldn't find handler!", fn)
            }
        }
    }

    onDragMove(fn: PointerDragCallback): DragManagerUnsubscribe {
        this.dragSubscriptions.push(fn);
        return this.unsubscriber(this.dragSubscriptions, fn);
    }

    onDragStart(fn: PointerDragCallback): DragManagerUnsubscribe {
        this.startSubscriptions.push(fn);
        return this.unsubscriber(this.startSubscriptions, fn);
    }

    onDragStop(fn: PointerDragCallback): DragManagerUnsubscribe {
        this.stopSubscriptions.push(fn);
        return this.unsubscriber(this.stopSubscriptions, fn);
    }
}

export const pointerDragManager = new PointerDragManager();
